import * as React from 'react';
export const IcWomenHealth = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16 16h-3v-2.09a5.995 5.995 0 003.74-2.24 6.043 6.043 0 001.24-4.18c-.13-1.5-.81-2.9-1.92-3.91A5.998 5.998 0 0012 2c-1.5 0-2.95.57-4.06 1.58a6.023 6.023 0 00-1.92 3.91c-.13 1.5.32 2.99 1.24 4.18A5.995 5.995 0 0011 13.91V16H8c-.27 0-.52.11-.71.29A.99.99 0 007 17c0 .27.11.52.29.71.19.19.44.29.71.29h3v3c0 .27.11.52.29.71.19.19.44.29.71.29.27 0 .52-.11.71-.29A.99.99 0 0013 21v-3h3c.27 0 .52-.11.71-.29A.99.99 0 0017 17c0-.27-.11-.52-.29-.71A.99.99 0 0016 16zm-4-4c-1.06 0-2.08-.42-2.83-1.17a4.004 4.004 0 01-.5-5.05 3.93 3.93 0 011.8-1.47c.73-.3 1.54-.38 2.31-.23.78.15 1.49.54 2.05 1.09.56.56.94 1.27 1.09 2.05.15.78.08 1.58-.23 2.31-.3.73-.82 1.36-1.47 1.8-.65.44-1.43.67-2.22.67zm1.65-5.34c-.11-.12-.24-.21-.39-.28-.15-.06-.3-.1-.46-.1-.3.01-.58.13-.8.34-.22-.21-.5-.33-.8-.34-.16 0-.32.03-.46.1-.15.06-.28.16-.39.28-.11.12-.2.26-.26.42-.06.16-.09.32-.09.49 0 .79.58 1.51 1.59 2.49l.11.1c.08.08.19.12.3.12.11 0 .22-.04.3-.12l.11-.1C13.42 9.08 14 8.36 14 7.57c0-.17-.03-.33-.09-.49-.06-.16-.15-.3-.26-.42z'
      fill='currentColor'
    />
  </svg>
);
